// extracted by mini-css-extract-plugin
export var content = "LandingTwoColumnListSection-module--content--c2d4b";
export var groupContent = "LandingTwoColumnListSection-module--groupContent--4d7d4";
export var heading = "LandingTwoColumnListSection-module--heading--25dec";
export var wrapper = "LandingTwoColumnListSection-module--wrapper--52f62";